import {put, takeEvery} from "redux-saga/effects";
import {Transaction} from "../../../Models/Transaction";
import {fillItems} from "../../utils";
import {
    transactionCreateError,
    transactionCreateSuccess,
    transactionLoadError,
    transactionLoadSuccess,
    transactionsGetError,
    transactionsGetSuccess,
    transactionUpdateError,
    transactionUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* transactionsSagas() {
    yield takeEvery(TYPES.TRANSACTIONS_GET_REQUEST, transactionsGetRequest);
    yield takeEvery(TYPES.TRANSACTION_LOAD_REQUEST, transactionLoadRequest);
    yield takeEvery(TYPES.TRANSACTION_CREATE_REQUEST, transactionCreateRequest);
    yield takeEvery(TYPES.TRANSACTION_UPDATE_REQUEST, transactionUpdateRequest);
}

function* transactionsGetRequest(action) {
    try {
        const response = yield Transaction.index({
            ...action.payload,
        });

        yield put(
            transactionsGetSuccess({
                ...fillItems(response, Transaction),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(transactionsGetError(error));
    }
}

function* transactionLoadRequest(action) {
    try {
        const response = yield Transaction.find(action.payload);

        yield put(
            transactionLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(transactionLoadError(error));
    }
}

function* transactionCreateRequest(action) {
    try {
        const response = yield Transaction.create(action.payload);

        yield put(
            transactionCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(transactionCreateError(error));
    }
}

function* transactionUpdateRequest(action) {
    try {
        const response = yield Transaction.update(action.payload.id, action.payload);

        yield put(
            transactionUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(transactionUpdateError(error));
    }
}
